// extracted by mini-css-extract-plugin
export var image = "styles-module--image--1rIN0";
export var mapText = "styles-module--mapText--1obAv";
export var mapViewButton = "styles-module--mapViewButton--2H3wg";